import { MedicationForm } from "~/components/form/health-profile/MedicationForm";
import { Authorize } from "~/components/permission/Authorize";
import { useDismiss } from "~/providers/DismissProvider";

export default function CreateMedication() {
    const { handleDismiss } = useDismiss();

    return (
        <Authorize ability="update" section="medications">
            <MedicationForm onRequestClose={handleDismiss} asRoute />
        </Authorize>
    );
}
